const GOOGLE_ANALYTICS_SCRIPT_ID = "bikeparksfinder-google-analytics";
export const ANALYTICS_CONSENT_KEY = "bikeparksfinder.analytics-consent";

export function getAnalyticsConsent() {
  try {
    return window.localStorage.getItem(ANALYTICS_CONSENT_KEY);
  } catch {
    return null;
  }
}

export function setAnalyticsConsent(value) {
  try {
    window.localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
  } catch {
    // Analytics is optional. If storage is unavailable, keep it disabled.
  }
}

export function initializeGoogleAnalytics(measurementId) {
  if (!measurementId || typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  if (!document.getElementById(GOOGLE_ANALYTICS_SCRIPT_ID)) {
    const script = document.createElement("script");
    script.id = GOOGLE_ANALYTICS_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    document.head.appendChild(script);
  }

  if (window.__bikeparksFinderGaMeasurementId !== measurementId) {
    window.gtag("js", new Date());
    window.gtag("config", measurementId, {
      send_page_view: false,
    });
    window.__bikeparksFinderGaMeasurementId = measurementId;
  }

  return true;
}

export function trackPageView(path) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
  });
}


export function trackEvent(name, params = {}) {
  if (!name || typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  const safeParams = Object.fromEntries(
    Object.entries(params).filter(([, value]) =>
      value !== undefined &&
      value !== null &&
      ["string", "number", "boolean"].includes(typeof value),
    ),
  );

  window.gtag("event", name, safeParams);
}
